import { render, staticRenderFns } from "./TaxInvoiceComponent.vue?vue&type=template&id=fb7157b6&scoped=true&"
import script from "./TaxInvoiceComponent.vue?vue&type=script&lang=js&"
export * from "./TaxInvoiceComponent.vue?vue&type=script&lang=js&"
import style0 from "../../assets/print.css?vue&type=style&index=0&id=fb7157b6&scoped=true&lang=css&"
import style1 from "./TaxInvoiceComponent.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb7157b6",
  null
  
)

export default component.exports